
import {permissionList} from "@/api/http";

const columnList: Array<column> = [
    {
        prop: "name",
        label: "分类名称",
        width: 179,
    },
    {
        prop: "sort",
        label: "排序",
        width: 179,
    },
];
import { Request } from "@/api/request";
import { defineComponent, ref, inject, onMounted, watch } from "vue";
import { column } from "@/assets/types/common";
import { storeUser } from "@/store/User";
export default defineComponent({
    name: "ProjectType",
    setup() {
        const setTitle: any = inject("setTitle"),
            headClass = inject("headClass");
        setTitle(["服务管理", "服务分类"]);
        let user = storeUser.getUser();
        let tableData = ref([] as any),
            loading = ref(false),
            pageSize = ref(10),
            currentPage = ref(1),
            roleList = ref({} as any),
            total = ref(0),
            // let edit = (data: any) => {
            //     console.log(data);
            // };
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = () => {
                loading.value = true;
                let data = {
                    type:1,
                    role_name:'projectType',
                }
                permissionList(data).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                Request.axiosInstance({
                    url: "adminapi/ProjectType/list",
                    data: {
                        page: currentPage.value,
                        pagesize: pageSize.value,
                    },
                }).then((res: any) => {
                    loading.value = false;
                    if (res.status == 200) {
                        tableData.value = res.content.list || [];
                        total.value = res.content.count;
                    }
                });
            };
        // onSubmit = () => {
        //     (formRef.value as any).validate((valid: boolean) => {
        //         if (valid) {
        //             let data = {},
        //                 url = "";
        //             if (dialogType.value == 1) {
        //                 url = "adminapi/VipClass/create";
        //                 data = form.value;
        //             } else {
        //                 url = "adminapi/VipClass/edit";
        //                 data = {
        //                     class_id: form.value.class_id,
        //                     class_name: form.value.class_name,
        //                 };
        //             }
        //             Request.axiosInstance({
        //                 url,
        //                 data,
        //             }).then((res: any) => {
        //                 dialogVisible.value = false;
        //                 if (res.status == 202) {
        //                     getVipCardList();
        //                 }
        //             });
        //         }
        //     });
        // };

        onMounted(() => {
            getTableData();
        });

        return {
            headClass,
            columnList,
            // edit,
            tableData,
            loading,
            pageSize,
            currentPage,
            total,
            handleSizeChange,
            handleCurrentChange,
            roleList,
        };
    },
});
